import React, { useState } from 'react';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import ContactForm from '../../Molecules/Contactform';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const ContactForms = ({className}) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';
        if (!formData.email) newErrors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
        if (!formData.phone) newErrors.phone = 'Phone number is required';
        else if (!/^\d{6,15}$/.test(formData.phone)) newErrors.phone = 'Phone number should be more than 8 digits.';
        if (!formData.message) newErrors.message = 'Message is required';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            setLoading(true);
            const res = await fetch('/api/inquiry', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            if (!res.ok) throw new Error('Failed to send');

            alert('Message sent successfully!');
            setFormData({ name: '', email: '', phone: '', message: '' });
        } catch (err) {
            alert('Error sending message.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className={className ? 'blade-margin-sm' : 'blade-margin-top-sm'}>
            <div className="2xl:pb-20 xl:pb-16 lg:pb-12 md:pb-8 pb-0 containers-min mx-auto">
                <h3 className="text-center font-gilroy">
                Schedule a Call
                </h3>
                <p className="my-3 md:my-5 lg:my-7 text-center font-poppins font-light">
                Partnering with us gets you complete transparency and hands-on support. VerdeMobility guides you every step of the way.
                </p>
            </div>
            {/* <form onSubmit={handleSubmit} className="bg-grey rounded-xl p-6 containers-min mx-auto text-white ">
                <div className="flex flex-col md:flex-row gap-4 mb-4">
                    <div className="w-full">
                        <label htmlFor="name" className="text-base font-poppins font-medium grow shrink flex flex-col gap-1 items-start uppercase text-black">
                            Name*
                        </label>
                        <input
                            id="name"
                            name="name"
                            placeholder="Your Name"
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full p-2 text-black rounded border border-black"
                        />
                        {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
                    </div>

                    <div className="w-full">
                        <label htmlFor="email" className="text-base font-poppins font-medium grow shrink flex flex-col gap-1 items-start uppercase text-black">
                            Email Address*
                        </label>
                        <input
                            id="email"
                            name="email"
                            placeholder="Email Address"
                            value={formData.email}
                            onChange={handleChange}
                            className="w-full p-2 text-black rounded border border-black"
                        />
                        {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
                    </div>

                    <div className="w-full">
                        <label htmlFor="phone" className="text-base font-poppins font-medium grow shrink flex flex-col gap-1 items-start uppercase text-black">
                            Phone Number*
                        </label>
                        <input
                            id="phone"
                            name="phone"
                            placeholder="Phone Number"
                            value={formData.phone}
                            onChange={handleChange}
                            className="w-full p-2 text-black rounded border border-black"
                        />
                        {errors.phone && <p className="text-red-500 text-sm">{errors.phone}</p>}
                    </div>
                </div>

                <div className="mb-4">
                    <label htmlFor="message" className="text-base font-poppins font-medium grow shrink flex flex-col gap-1 items-start uppercase text-black">
                        Message*
                    </label>
                    <textarea
                        id="message"
                        name="message"
                        rows={4}
                        placeholder="Your Message"
                        value={formData.message}
                        onChange={handleChange}
                        className="w-full p-2 text-black rounded border border-black"
                    />
                    {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
                </div>

                <div className="text-center">
                    <div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6"
                        >
                            <span className="flex justify-center items-center">
                                <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                            </span>
                            {loading ? 'Sending...' : 'INQUIRE NOW'}
                        </button>
                    </div>
                </div>
            </form> */}
            <div>
                <ContactForm className="!bg-none"/>
            </div>
        </section>

    );
};

export default ContactForms;
